/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_3_AInputs */

const en_mk_pricing_faq_3_a = /** @type {(inputs: Mk_Pricing_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rupiah via Midtrans for teams in Indonesia; USD via Paddle for international payments.`)
};

const id_mk_pricing_faq_3_a = /** @type {(inputs: Mk_Pricing_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rupiah lewat Midtrans untuk tim Indonesia; USD lewat Paddle untuk pembayaran internasional.`)
};

/**
* | output |
* | --- |
* | "Rupiah via Midtrans for teams in Indonesia; USD via Paddle for international payments." |
*
* @param {Mk_Pricing_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_3_a = /** @type {((inputs?: Mk_Pricing_Faq_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_3_a(inputs)
	return en_mk_pricing_faq_3_a(inputs)
});